import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, nextTick, computed, defineAsyncComponent, type Ref } from 'vue'
import parsePhoneNumber from 'libphonenumber-js'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneInput',
  props: {
  modelValue: {},
  defaultCountry: String,
  onInput: Function,
  onChange: Function,
},
  emits: [
  'update:country',
  'update:modelValue',
  'update:is-valid',
],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const MazPhoneNumberInput = computed(() =>
  defineAsyncComponent(() => import('maz-ui/components/MazPhoneNumberInput'))
)
const { t } = useI18n()

const props = __props

const emit = __emit

const phoneValue = ref()
const countryCode: Ref<string> = ref(props.defaultCountry)
const isInit = ref(false)

// const dropdownOptions = {
//   showSearchBox: true,
//   showFlags: true,
//   showDialCodeInSelection: true,
//   showDialCodeInList: true,
// }

// watch(() => props.phone, (newValue, old) => {
//   if (newValue !== phoneValue.value) {
//     phoneValue.value = newValue
//   }
// })

const trans = ref({
  countrySelector: {
    placeholder: null,
    error: t('Choose country'),
  },
  phoneInput: {
    placeholder: '',
    example: t('Example:'),
  },
})
onMounted(() => {
  if (props.modelValue) {
    const parsedPhone = parsePhoneNumber(props.modelValue)
    countryCode.value = parsedPhone?.country
    phoneValue.value = parsedPhone?.nationalNumber || ''
  }
})

function setNumber(val) {
  if (val.countryCode) {
    countryCode.value = val.countryCode || countryCode.value
  }
  if (val?.uri) {
    emit('update:modelValue', val.e164)
    emit('update:country', val)
    emit('update:is-valid', val.isValid)
  } else {
    if (!isInit.value) {
      emit('update:is-valid', true)
      isInit.value = true
    } else {
      emit('update:is-valid', val.isValid)
    }
  }
}

const __returned__ = { MazPhoneNumberInput, t, props, emit, phoneValue, countryCode, isInit, trans, setNumber, ref, onMounted, nextTick, computed, defineAsyncComponent, get parsePhoneNumber() { return parsePhoneNumber }, get useI18n() { return useI18n } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})